import Notify                                              from "../../../domain/fundamentals/message/notify/Notify";
import NotifyMessage
                                                           from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyType
                                                           from "../../../domain/fundamentals/message/notify/NotifyType";
import NotifyTypeClass
                                                           from "../../../domain/fundamentals/message/notify/NotifyTypeClass";
import { ACTION_TYPE, NotifyAction, NotifyOptionalAction } from "./NotifyAction";

const notifyReducer = (state: Notify = new Notify(), action: NotifyAction): Notify => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.NOTIFY_INIT:
      return new Notify();
    case ACTION_TYPE.NOTIFY_SAVE_SUCCESS:
      return new Notify(new NotifyTypeClass(NotifyType.SAVE_SUCCESS), new NotifyMessage("保存しました。"));
    case ACTION_TYPE.NOTIFY_SAVE_FAILURE:
      return new Notify(new NotifyTypeClass(NotifyType.SAVE_FAILURE), new NotifyMessage("保存できませんでした。画面上のメッセージをご確認ください。"));
    case ACTION_TYPE.NOTIFY_DELETE_SUCCESS:
      return new Notify(new NotifyTypeClass(NotifyType.DELETE_SUCCESS), new NotifyMessage("削除しました。"));
    case ACTION_TYPE.NOTIFY_DELETE_FAILURE:
      return new Notify(new NotifyTypeClass(NotifyType.DELETE_FAILURE), new NotifyMessage("削除できませんでした。時間を置いて再度お試しください。"));
    case ACTION_TYPE.NOTIFY_FETCH_FAILURE:
      return new Notify(new NotifyTypeClass(NotifyType.FETCH_FAILURE), new NotifyMessage("データが取得できませんでした。時間を置いて再度お試しください。"));
    case ACTION_TYPE.NOTIFY_MAIL_SEND_SUCCESS:
      return new Notify(new NotifyTypeClass(NotifyType.MAIL_SEND_SUCCESS), new NotifyMessage("メールを送信しました。"));
    case ACTION_TYPE.NOTIFY_OPTIONAL_MESSAGE:
      return new Notify(new NotifyTypeClass((action as NotifyOptionalAction).notifyType), (action as NotifyOptionalAction).notifyMessage);
  }
};

export default notifyReducer;